import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Phone, Cookie, ClipboardCheck, Mail } from "lucide-react";
import { COMPANY } from "./data";
import { EASE, requestOffer } from "./scroll";
import { WhatsAppIcon } from "./icons";

export const CookieBanner = ({ consent, setConsent }) => (
  <AnimatePresence>
    {!consent && (
      <motion.div role="dialog" aria-label="Cookie-Hinweis"
        className="fixed inset-x-3 bottom-[156px] z-[70] border border-white/10 bg-ink2/95 p-5 shadow-2xl backdrop-blur-xl sm:p-6 lg:inset-x-auto lg:bottom-6 lg:right-[104px] lg:max-w-md"
        initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }} transition={{ duration: 0.6, ease: EASE, delay: 0.8 }}
        data-testid="cookie-banner">
        <p className="flex items-center gap-3 font-display text-2xl font-bold uppercase text-white"><Cookie size={20} className="text-terra" /> Datenschutz</p>
        <p className="mt-3 text-sm leading-relaxed text-slate-300">
          Wir speichern nur, was technisch notwendig ist. Google Maps laden wir erst nach Ihrer Zustimmung. Mehr in der{" "}
          <Link to="/datenschutz" className="text-white underline underline-offset-4" data-testid="cookie-privacy-link">Datenschutzerklärung</Link>.
        </p>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row">
          <button type="button" onClick={() => setConsent("essential")} className="btn-ghost flex-1 justify-center !px-4 !py-3" data-testid="cookie-essential-btn">Nur notwendige</button>
          <button type="button" onClick={() => setConsent("all")} className="btn-primary flex-1 justify-center !px-4 !py-3" data-testid="cookie-accept-btn">Alle akzeptieren</button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

const barBtn = "inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full px-2 py-3.5 text-[0.78rem] font-bold uppercase tracking-[0.03em] transition-[background-color,transform] duration-300 active:scale-[0.97]";

export const StickyBar = () => (
  <div className="fixed inset-x-0 bottom-0 z-[60] grid grid-cols-[1fr_auto_1fr] gap-2 border-t border-white/10 bg-ink/95 p-2.5 backdrop-blur-xl lg:hidden" data-testid="mobile-sticky-bar">
    <a href={COMPANY.phoneHref} className={`${barBtn} bg-terra-deep text-white`} data-testid="sticky-call-btn"><Phone size={17} /> Jetzt anrufen</a>
    <a href={`mailto:${COMPANY.email}`} aria-label="E-Mail schreiben" className={`${barBtn} border border-white/25 !px-4 text-white`} data-testid="sticky-email-btn"><Mail size={18} /></a>
    <button type="button" onClick={() => requestOffer("Dachcheck & Beratung")} className={`${barBtn} bg-white text-ink`} data-testid="sticky-offer-btn"><ClipboardCheck size={17} /> Angebot anfordern</button>
  </div>
);

export const WhatsAppFab = () => (
  <a href={COMPANY.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Per WhatsApp schreiben"
    className="group fixed bottom-[84px] right-4 z-[61] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform duration-300 hover:scale-110 lg:bottom-6 lg:right-6 lg:h-16 lg:w-16"
    data-testid="whatsapp-fab">
    <WhatsAppIcon className="h-8 w-8" />
    <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-white px-4 py-2 text-sm font-bold text-ink opacity-0 shadow-xl transition-opacity duration-300 group-hover:opacity-100 lg:block">Fragen? Schreiben Sie uns</span>
  </a>
);
